<template>
  <div>
    <header class="sticky">
      <div class="d-header">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 head-st">
              <div class="logo">
                <img class="img-responsive" src="@/assets/images/Logo.png" alt="logo" />
              </div>
              <div class="title-head pr-2">{{$t('project_overview')}}</div>
              <div class="user-icon">
                <span style="width: 40px; margin-right: 40px;">
                  <a href="https://projectdocu.com/hilfe-und-tutorials-baustellendokumentation/" target="_blank" style="color:#666666; position: absolute;"  alt="Hilfe & Anleitungen" title="Hilfe & Anleitungen">
                    <i class="fa-regular fa-circle-question" style="font-size: 35px;margin-top: 5px;"></i>
                  </a>
                </span>
<!--                <span>-->
<!--                  <img class src="@/assets/images/user.png" alt="user" width="40" />-->
<!--                </span>-->
                <span class="u-txt">{{ nameShowInheader }}</span>
                <span class="u-dp">
                  <div class="dropdown show">
                    <img class="img-responsive dropdown-toggle arrow-img" src="@/assets/images/dropdown.png" alt="user" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
                    <div class="dropdown-menu dropdown-menu-right dp-box" aria-labelledby="dropdownMenuLink">
                      <a class="dropdown-item" data-toggle="modal" data-target="#exampleModalCenter"  href="#"  @click="emptyModal">
                        <img class="img-responsive" src="@/assets/images/Shape.png" alt="shapw" />
                        <span>{{$t('profile_edit')}}</span>
                      </a>
                      <a class="dropdown-item" data-toggle="modal" data-target="#exampleModalCenter2" href="#">
                        <img class="img-responsive" src="@/assets/images/Shape1.png" alt="shapw" />
                        <span>{{$t('language')}}</span>
                      </a>

                      <template v-if="isCustomerAdmin">
                          <div style="background-color: white !important;"
                               class="dropdown-item"
                               @mouseover="showcustomerdropdown = true"
                               @mouseleave="showcustomerdropdown = false">
                            <img class="img-responsive" src="@/assets/images/Shape2.png" alt="shapw" />
                            <span>Kundenverwaltung</span>
                            <div class="" v-if="showcustomerdropdown">
                              <template  v-for="(item,i) in customers">
                                <a class="dropdown-item" v-bind:href="'/customer/' + item.customer_id" style="margin-left:20px;">
                                  <span>{{ item.customer.company_name }}</span>
                                </a>
                              </template>
                            </div>
                          </div>
                      </template>
<!--                      <a class="dropdown-item" href="#">-->
<!--                        <img class="img-responsive" src="@/assets/images/Shape2.png" alt="shapw" />-->
<!--                        <span>{{ $t('customer_administration') }}-->
<!--                        </span>-->
<!--                      </a>-->
                      <a class="dropdown-item" href="#" @click="logout()">
                        <img class="img-responsive" src="@/assets/images/Shape3.png" alt="shapw" />
                        <span>{{$t('logout')}}</span>
                      </a>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Navbar-->
      <div class="m-header">
        <nav class="navbar navbar-light light-blue lighten-4">
          <!-- Navbar brand -->
          <a class="navbar-brand logo" href="#">
            <img class="img-responsive" src="@/assets/images/Logo.png" alt="logo" />
          </a>

          <!-- Collapse button -->
          <button
            class="navbar-toggler toggler-example"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent1"
            aria-controls="navbarSupportedContent1"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="dark-blue-text">
              <i class="fa fa-bars fa-1x"></i>
            </span>
          </button>

          <!-- Collapsible content -->
          <div class="collapse navbar-collapse" id="navbarSupportedContent1">
            <!-- Links -->
            <ul class="navbar-nav mr-auto">
              <li class="nav-item">
                <a class="nav-link" href="#">Alle Projekte</a>
              </li>
<!--              <li class="nav-item">-->
<!--                <a class="nav-link" href="#">Favoriten Projekte</a>-->
<!--              </li>-->
              <li class="nav-item">
                <a class="nav-link" href="#">Archivierte Projekte</a>
              </li>
              <li
                class="nav-item"
                data-toggle="collapse"
                data-target="#navbarSupportedContent2"
                aria-controls="navbarSupportedContent2"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <a class="nav-link" href="#">
                  <img class src="@/assets/images/user.png" alt="user" />
                  <span class="u-txt">{{user.firstname}} {{user.lastname}}</span>
                  <span class="u-dp">
                    <img class="img-responsive arrow-img" src="@/assets/images/dropdown.png" alt="dropdown"/>
                  </span>
                </a>
              </li>
              <div class="collapse navbar-collapse2" id="navbarSupportedContent2">
                <!-- Links -->
                <ul class="navbar-nav mr-auto">
                  <li class="nav-item" data-toggle="modal" data-target="#exampleModalCenter">
                    <a class="nav-link" href="#">
                      <img class="img-responsive" src="@/assets/images/Shape.png" alt="shapw" />
                      <span>{{ $t("profile_edit")}}</span>
                    </a>
                  </li>
                  <li class="nav-item" data-toggle="modal" data-target="#exampleModalCenter2">
                    <a class="nav-link" href="#">
                      <img class="img-responsive" src="@/assets/images/Shape1.png" alt="shapw" />
                      <span>{{ $t("language")}}</span>
                    </a>
                  </li>
<!--                  <li class="nav-item">-->
<!--                    <a class="nav-link" href="#">-->
<!--                      <img class="img-responsive" src="@/assets/images/Shape2.png" alt="shapw" />-->
<!--                      <span>{{ $t("customer_administration")}}</span>-->
<!--                    </a>-->
<!--                  </li>-->
                  <li class="nav-item">
                    <a class="nav-link" href="#">
                      <img class="img-responsive" src="@/assets/images/Shape3.png" alt="shapw" />
                      <span>{{ $t("logout")}}</span>
                    </a>
                  </li>
                </ul>
                <!-- Links -->
              </div>
            </ul>
            <!-- Links -->
          </div>
          <!-- Collapsible content -->
        </nav>
      </div>
      <div class="spinner-cover" style="display: none;">
        <div class="spinner"></div>
      </div>
      <!--/.Navbar-->

      <div class="main-content">
        <div class="conatiner-fluid">
          <div class="head" id="head">

            <div
              @click="openTab('DataB')"
              class="head-title tab_favourite_btn"
              :class="{ active: tabB }"
              v-if="hasFavorites"
            >{{ $t("favorite") }} {{ $t("projects") }}</div>

            <div
              @click="openTab('DataA')"
              :class="{ active: tabA }"
              class="head-title tab_projects_btn"
            >{{ $t("all") }} {{ $t("projects") }}</div>
            <div
              @click="openTab('DataC')"
              class="head-title tab_archive_btn"
              :class="{ active: tabC }"
            >{{ $t("archived") }} {{ $t("projects") }}</div>
          </div>
        </div>

        <div class="conatiner-fluid">
          <div class="row search-bar">
            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
              <div class="form-group has-search mb-2">
                <i class="fa fa-search form-control-feedback  search-img" style="top: -9px; font-size: 15px"></i>
                <input v-model="search" type="text" class="form-control" v-bind:placeholder="$t('search')" style="height: 35px" />
              </div>
            </div>
            <div class="col-lg-4 col-md-5 col-sm-4 pl-md-0 pr-md-0">
              <label class="d-inline-block pr-2" style="color: #495057; font-size: 1rem; font-weight: normal">Sortierung</label>
              <div class="sorting-photos d-inline-block">
                <div style="height: 35px; line-height: 20px" class="dropdown form-control mr-4 sorting sorting-project">
                  <button class="dropdown-toggle sorting-dropdown-btn" type="button" id="dropdownMenuButton22"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span v-if="sort === 'd_asc'"> <span class="pl-1" style="font-size: 14px">Datum</span>  <span class="pl-1">&#8593;</span> </span>
                    <span v-else-if="sort === 'd_dsc'"> <span class="pl-1" style="font-size: 14px">Datum</span>  <span class="pl-1">&#x2193;</span> </span>

                    <span v-else-if="sort === 'n_asc'">  <span class="pl-1" style="font-size: 14px">Name</span>
<!--                      <span class="pl-1">&#8593;</span>-->
                      <i class="fa-solid fa-arrow-down-z-a"></i>
                    </span>


                    <span v-else-if="sort === 'n_dsc'">  <span class="pl-1" style="font-size: 14px">Name</span>
<!--                      <span class="pl-1">&#x2193;</span> -->
                      <i class="fa-solid fa-arrow-down-a-z"></i>
                    </span>

                    <span v-else>  <span class="pl-1">Sortierung</span> </span>
                  </button>
                  <div class="dropdown-menu sorting-projects order-by shadow-sm" aria-labelledby="dropdownMenuButton22" style="max-width: 130px">
                    <a class="dropdown-item" @click.prevent="sortByDateDesc(); sort = 'd_dsc'" href="#">
                        <span :class="{'font-weight-bold': sort === 'd_dsc'}" class="pl-1">Datum</span>  <span class="pl-1">&#x2193;</span>
                    </a>
                    <a class="dropdown-item" @click.prevent="sortByDateAsc(); sort = 'd_asc'"  href="#">
                        <span :class="{'font-weight-bold': sort === 'd_asc'}" class="pl-1">Datum</span>  <span class="pl-1">&#8593;</span>
                    </a>

                    <a class="dropdown-item" @click.prevent="sortByNameDesc(); sort = 'n_dsc'" href="#">
                      <span :class="{'font-weight-bold': sort === 'n_dsc'}" class="pl-1">Name (A-Z)</span>
                      <!--                      <span class="pl-1">&#x2193;</span>-->
                    </a>

                    <a class="dropdown-item" @click.prevent="sortByNameAsc(); sort = 'n_asc'"  href="#">
                        <span :class="{'font-weight-bold': sort === 'n_asc'}" class="pl-1">Name (Z-A)</span>
<!--                      <span class="pl-1">&#8593;</span>-->
                    </a>



                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-3 col-sm-4 col-xs-12 profile-btn p-0">
              <button type="button" data-toggle="modal" data-target="#exampleModalCenter3" class="btn btn-createproject">
                {{ $t("create_project") }}
                <i class="fa fa-plus-circle ml-1" style="font-size: 19px; vertical-align: text-bottom"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- Modal 1-->
    <div
      class="modal fade"
      id="exampleModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="response-alert">
        <div class="alert alert-success alert-dismissible" v-for="m in modal3">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
          <strong></strong>
          {{m}}
        </div>
        <div class="alert alert-danger alert-dismissible" v-for="e in emodal3">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
          <strong></strong>
          {{e}}
        </div>
      </div>
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="spinner-cover" style="display: block;">
        <div class="spinner"></div>
      </div>
        <div class="modal-content col-lg-7 col-md-9 col-xl-6 col-sm-11" style="margin: 0 auto;">
          <form @submit.prevent="updateProfile()" class="form-border-none" >
            <div class="modal-body">
              <div class="row row-data">
                <div class="col-12 pro-style">{{ $t("profile_edit")}}</div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-1st">
                  <img class src="@/assets/images/user.png" alt="user" />
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-2nd">
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                      <label class="form-label">{{ $t("email")}} {{ $t("address")}} ({{ $t("user_name")}}) *</label>
                      <div class="input-group">
                        <input
                          readonly
                          class="input--style-2"
                          type="text"
                          v-model="user.email"
                          @blur="$v.user.email.$touch()"
                          :class="{ 'is-invalid': submitted && $v.user.email.$error }"/>
                      </div>
                      <div v-if="submitted && !$v.user.email.email || (submitted && !$v.user.email.required)"
                        class="text-danger">{{ $t('email') }} {{ $t('is_required') }}</div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                      <label class="form-label">{{ $t("salutation")}} *</label>
                      <select
                        class="custom-select cus-select custom-select-sm mb-3 mt-1 select-box"
                        v-model="user.gender"
                        @blur="$v.user.gender.$touch()"
                        :class="{ 'is-invalid': submitted && $v.user.gender.$error }">
                        <option value="0">{{$t("mr")}}</option>
                        <option value="1">{{$t("mrs")}}</option>
                      </select>
                      <div
                        v-if="submitted && !$v.user.gender.required"
                        class="text-danger"
                      >{{ $t('salutation') }} {{ $t('is_required') }}</div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                      <label class="form-label">{{ $t("title")}}</label>
                      <div class="input-group">
                        <input class="input--style-2" type="text" v-model="user.title"/>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                      <label class="form-label">{{ $t("first_name")}} *</label>
                      <div class="input-group">
                        <input
                          class="input--style-2"
                          type="text"
                          name="name"
                          v-model="user.firstname"
                          @blur="$v.user.firstname.$touch()"
                          :class="{ 'is-invalid': submitted && $v.user.firstname.$error }"
                        />
                      </div>
                      <div
                        v-if="submitted && !$v.user.firstname.required" class="text-danger">{{ $t('first_name') }} {{ $t('is_required') }}</div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                      <label class="form-label">{{ $t("last_name")}} *</label>
                      <div class="input-group">
                        <input
                          class="input--style-2"
                          type="text"
                          name="name"
                          v-model="user.lastname"
                          @blur="$v.user.lastname.$touch()"
                          :class="{ 'is-invalid': submitted && $v.user.lastname.$error }"
                        />
                      </div>
                      <div
                        v-if="submitted && !$v.user.lastname.required"
                        class="text-danger"
                      >{{ $t('last_name') }} {{ $t('is_required') }}</div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label class="form-label">{{ $t("company")}} *</label>
                      <div class="input-group">
                        <input
                          @blur="$v.user.company.$touch()"
                          :class="{ 'is-invalid': submitted && $v.user.company.$error }"
                          class="input--style-2"
                          type="text"
                          name="name"
                          v-model="user.company"
                        />
                      </div>
                      <div
                        v-if="submitted && !$v.user.company.required"
                        class="text-danger"
                      >{{ $t('company') }} {{ $t('is_required') }}</div>
                    </div>
                  </div>

                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-3rd" style="display:none;">
                  <span style="font-weight: 500">
                    <img class src="@/assets/images/Group.png" alt="user" />
                    &nbsp;&nbsp; {{ $t("passwordc") }}
                  </span>
                  <div class="group-txt">{{ $t("change_account_password") }}</div>
                  <div v-if="passwordChange">
                    <div class="sm-form">
                      <form @submit.prevent="updatePassword()" class="needs-validation" novalidate>
                        <div class="row">
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <label class="form-label1">{{ $t('current_password') }} *</label>
                            <div class="input-group inp">
                              <input
                                class="input--style-2 form-control"
                                type="password"
                                name="name"
                                v-model="currentpassword"
                                @blur="$v.currentpassword.$touch()"
                                :class="{ 'is-invalid':submitted1 && $v.currentpassword.$error }"
                              />
                              <!--<div v-if="!$v.currentpassword.required" class="invalid-feedback">
                                {{ $t('current_password') }} {{ $t('is_required') }}
                              </div>-->
                              <div class="valid-feedback"></div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <label class="form-label1">{{ $t('new_password') }} *</label>
                            <div class="input-group inp">
                              <input
                                class="input--style-2 form-control"
                                type="password"
                                name="name"
                                v-model="password"
                                @blur="$v.password.$touch()"
                                :class="{ 'is-invalid':submitted1 && $v.password.$error }"
                              />
                              <!--<div v-if="!$v.currentpassword.required" class="invalid-feedback">
                                      {{ $t('current_password') }} {{ $t('is_required') }}
                              </div>-->
                              <div
                                v-if="$v.password.required && !$v.password.minLen"
                                class="invalid-feedback"
                              >{{ $t('password') }} {{ $t('must_be_at_least') }} {{$v.password.$params.minLen.min}} {{ $t('characters') }}</div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <label class="form-label1">{{ $t('confirm_password') }} *</label>
                            <div class="input-group inp">
                              <input
                                class="input--style-2 form-control"
                                type="password"
                                name="name"
                                v-model="repeatpassword"
                                @blur="$v.password.$touch()"
                                :class="{ 'is-invalid':submitted1 && $v.repeatpassword.$error }"
                              />

                              <div
                                v-if="$v.repeatpassword.$error"
                                class="invalid-feedback"
                              >{{ $t('password') }} {{ $t('not_matched') }}</div>
                            </div>
                          </div>
                        </div>

                        <div class="p-t-30">
                          <!-- <button class="btn btn-sf btn--radius btn--green" type="submit">save</button>
                        <button
                    type="button"
                    @click="passwordChange=!passwordChange"
                    class="btn btn-sf btn--radius btn--green"
                          >{{ $t("hide") }}</button>-->
                        </div>
                      </form>
                    </div>
                  </div>
                  <button
                    type="button"
                    v-if="!passwordChange"
                    @click="passwordChange='false'"
                    class="btn btn-light btn-sm btn-small"
                  >{{ $t("change") }}</button>
                </div>
              </div>
            </div>
            <div class="modal-footer mf-1st">
              <button
                type="button"
                class="btn mode-d"
                data-dismiss="modal"
              >{{ $t("cancel")}}</button>
              <button type="submit" class="btn btn-primary mode-s">{{ $t("save")}}</button>
              <div class="cross-close" data-dismiss="modal">
                <img src="@/assets/images/cross.png" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- modal 2-->

    <!-- Modal 2-->
    <div
      class="modal fade"
      id="exampleModalCenter2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content col-6" style="margin: 0 auto;">
          <form @submit.prevent="changeLang()">
            <div class="modal-body">
              <div class="row row-data">
                <div class="col-12 pro-style2">{{$t("set_the_language")}}</div>

                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="custom-control custom-radio cus-radio">
                    <input
                      type="radio"
                      class="custom-control-input"
                      id="customRadio"
                      value="de"
                      v-model="lang"/>
                    <label class="custom-control-label" for="customRadio">
                      <span class="img-flag">
                        <img class="img-responsive" src="@/assets/images/germany.png" alt="user" />
                      </span>
                      <span class="language">Deutsch</span>
                    </label>
                  </div>

                </div>
              </div>
            </div>
            <div class="modal-footer mf-1st">
              <button
                type="button"
                class="btn
                 mode-d"
                data-dismiss="modal"
              >{{ $t("cancel") }}</button>
              <button type="submit" class="btn btn-primary mode-s">{{ $t("save") }}</button>
              <div class="cross-close" data-dismiss="modal">
                <img src="@/assets/images/cross.png" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import axios from 'axios'
import axios from '../../utils/axiosinstance'
import {
  required,
  email,
  minLength,
  numeric,
  sameAs
} from 'vuelidate/lib/validators'
import user from '../appSetting/components/Users'
export default {
  name: 'HelloWorld',
  data () {
    return {
      sort: 'd_dsc',
      submitted: false,
      nameShowInheader: '',
      submitted1: true,
      passwordChange: false,
      lang: this.$i18n.locale,
      currentpassword: '',
      password: '',
      repeatpassword: '',
      isCustomerAdmin: false,
      customers: [],
      showcustomerdropdown: false,
      user: {
        pduserid: '',
        email: '',
        created: '',
        lastlogin: '',
        status: '',
        gender: '0',
        title: '',
        firstname: '',
        lastname: '',
        company: '',
        street: '',
        zipcode: '',
        city: '',
        country: '',
        description: '',
        language: '',
        emailinfo: null,
        telefon: ''
      },
      modal3: [],
      emodal3: [],
      tabA: 1,
      tabC: 0,
      tabB: 0,
      search: ''
    }
  },
  created () {
    this.getrecord(); // Benjamin: Auskommentiert - Adaption?
    this.getiscustomeradmin();
  },
  validations () {
    if (this.passwordChange) {
      return {
        currentpassword: { required },
        password: { required, minLen: minLength(6) },
        repeatpassword: { required, sameAs: sameAs('password') },
        user: {
          firstname: { required },
          email: { required, email },
          lastname: { required },
          company: { required },
          gender: { required },
          telefon: { numeric }
        }
      }
    } else {
      return {
        user: {
          firstname: { required },
          email: { required, email },
          lastname: { required },
          company: { required },
          gender: { required },
          telefon: { numeric }
        }
      }
    }
  },
  beforeCreate () {
    if (!localStorage.apikey) this.$router.push('/login')
  },

  computed: {
    hasFavorites () {
      let hasfavs = false
      for(let i = 0; i < this.$store.state.projects.projects.length; i++) {
        if(this.$store.state.projects.projects[i].isfav) {
          hasfavs = true
        }
      }
      return hasfavs
    }
  },

  methods: {
    async getiscustomeradmin() {
      let _this = this;
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [],
        serviceName: "ProjectdocuCustomer",
        methodName: "iscustomeradmin"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        console.log(response)
        if(response.data == false) {
          // Do Nothing because is not admin!
          _this.isCustomerAdmin = false
        } else {
          _this.isCustomerAdmin = true
          _this.customers = response.data
        }

        console.log('This', _this.isCustomerAdmin, _this.customers)


        // this.$store.commit('setAuthUser',response.data[0]);
        // this.user = response.data[0]
        // localStorage.user = this.user
        // if (this.user.firstname === "" && this.user.lastname === "" && this.user.city === "" && this.user.street === ""){
        //   $('#exampleModalCenter').modal('show');
        // }
        // this.nameShowInheader = this.user.firstname + ' ' + this.user.lastname
      }).catch(e => {
        // localStorage.clear()
        // this.$router.push('/login')
      });
    },
    sortByDateDesc () {
      this.$store.state.projects.activeprojects.sort((a, b) => new Date(b.startdate.replaceAll('-','/')) - new Date(a.startdate.replaceAll('-','/')))

    },
    sortByDateAsc () {
      this.$store.state.projects.activeprojects.sort((a, b) => new Date(a.startdate.replaceAll('-','/')) - new Date(b.startdate.replaceAll('-','/')))
    },
    sortByNameDesc () {
      this.$store.state.projects.activeprojects.sort((a, b) => a.name.localeCompare(b.name))
    },
    sortByNameAsc () {
      this.$store.state.projects.activeprojects.sort((a, b) => b.name.localeCompare(a.name))
    },
    changeLang () {
      this.$i18n.locale = this.lang
      localStorage.locale = this.lang
      $('#exampleModalCenter2').modal('hide')
    },


   async getrecord () {
     await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
          parameters: [],
          serviceName: "ProjectdocuService",
          methodName: "getCurrentUser"
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(response => {
          this.$store.commit('setAuthUser',response.data[0]);
          this.user = response.data[0]
          localStorage.user = this.user
          if (this.user.firstname === "" && this.user.lastname === "" && this.user.city === "" && this.user.street === ""){
            $('#exampleModalCenter').modal('show');
          }
          this.nameShowInheader = this.user.firstname + ' ' + this.user.lastname
        }).catch(e => {
          localStorage.clear()
          this.$router.push('/login')
        });
    },


   async logout () {
      localStorage.apikey = null
      await this.$store.dispatch('logout');
      await this.$router.push('/login')
    },
    updateProfile () {
      this.submitted = true
      let _this = this
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      if (this.passwordChange) {
        this.user.password = this.password
        this.user.password_rpt = this.repeatpassword
      }
      $('.spinner-cover').show()

      const params = [this.user.pduserid, this.user]
      axios.post(process.env.VUE_APP_BASE_AMF_URL + `user/saveprofile`  + `&token=` + localStorage.sessiontoken,
          {
            parameters: params,
            serviceName: "ProjectdocuService",
            methodName: "updateUser"
          },
          {
            headers: {
              apitoken: localStorage.apikey,
              deviceid: localStorage.deviceid,
              accept: 'application/json'
            }
          }
        ).then(response => {
          if (response.status === 200) {
            _this.$toast.success('Profil erfolgreich aktualisiert')
          }
          $('.spinner-cover').hide()
        })
        .catch(e => {
          $('.spinner-cover').hide()
          this.emodal3.push(e)
          console.log(e)

          // this.errors.push(e);
        })
    },

    updatePassword () {
      this.submitted1 = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      var params = new URLSearchParams()
      // params.append("api_token", localStorage.token);
    },
    emptyModal () {
      this.modal3 = []
      this.emodal3 = []
      this.passwordChange = false
    },
    openTab (dataName) {
      this.tabA = this.tabB = this.tabC = 0
      if (dataName == 'DataA') this.tabA = 1
      if (dataName == 'DataB') this.tabB = 1
      if (dataName == 'DataC') this.tabC = 1
      let i
      let x = document.getElementsByClassName('d1')
      for (i = 0; i < x.length; i++) {
        x[i].style.display = 'none'
      }
      document.getElementById(dataName).style.display = 'block'
    }
  },
  watch: {
    search: function (val) {
      this.$store.state.projects.search = val
    },
    modal3: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    msg: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    emodal3: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    error: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    }
  }
}
</script>
<style scoped>
.profile-btn .btn-light:hover{
  background: #3498db;
  color: white !important;
}
.sorting-project .dropdown-toggle::after {
  font-size: 1.5rem;
  position: absolute;
  top: 3px;
  right: 1px;
  padding: 14px;
}
.dropdown-menu.order-by span.mrk{
  visibility: hidden;
}
.dropdown-menu.order-by span.visible{
  visibility: visible;
}
.dropdown-menu.sorting-projects{
  top: 10px !important;
  left: -11px !important;
}
.search-bar div.sorting-photos{
  width: 145px;
}
@media (max-width: 1100px){
  .main-content {
    padding: 0 55px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/projects/Header.vue